import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import DeviceHub from "@material-ui/icons/DeviceHub";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  ...regularFormsStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  legendContainer: {
    textAlign: "center"
  },
  myText: {
    textAlign: "left",
    marginTop: "40px",
    marginBottom: "40px",
    marginLeft: "20px"
  }
};

const NatOnCard = props => {
  const { classes } = props;

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <DeviceHub />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          NAT (Network Address Translation)
        </h4>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} className={classes.legendContainer}>
            <div className={classes.myText}>
              <h4>
                Your radio is configured to use NAT (Network Address
                Translation). Please call MCSnet Support if you want to change
                this setting.
              </h4>
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(NatOnCard);
